<template lang="pug">
.customer-compact-detail-header.d-flex
  CustomerPicture(:imgSrc='data.image' :grade='data.grade')
  .detail.ml-4
    .title {{ data.name }}
    .address {{ data.address }}

    .customer-data.mt-3
      .item.w-50
        .key เบอร์ติดต่อ
        .value {{ data.phone }}

    //- .customer-data.mt-3(v-if='showUnpaid')
    //-   .item.w-50.pb-3
    //-     .key รายการค้างชำระ
    //-     .value.red
    //-       | {{ data.unpaid.count }} รายการ
    //-   .item.w-50.pb-3
    //-     .key ยอดค้างชำระ
    //-     .value.red(v-if='data.unpaid && data.unpaid.total')
    //-       | {{ data.unpaid.total | currency }}
    //-   .item.w-50.pb-3
    //-     .key วงเงินคงเหลือ
    //-     .value.green(v-if='data.remaining')
    //-       | {{ data.remaining | currency }}
    //-   .item.w-50.pb-3
    //-     .key มูลค่าเช็คสูงสุด
    //-     .value.green(v-if='data.mostExpensiveCheque')
    //-       | {{ data.mostExpensiveCheque | currency }}
</template>

<script>
import CustomerPicture from '@/components/customers/CustomerPicture.vue';

export default {
  props: {
    data: {
      default: {
        image: '',
      },
    },
    // showUnpaid: {
    //   default: true,
    // },
  },
  components: {
    CustomerPicture,
  },
};
</script>

<style lang="scss">
.customer-compact-detail-header {
  // ...
  .detail {
    .title {
      font-size: 22px;
    }
    .address {
      color: #6B6C6F;
      font-size: 17px;
    }
  }
}

.customer-data {
  display: flex;
  flex-wrap: wrap;
  .item {
    .key {
      font-size: 15px;
      opacity: 0.5;
      letter-spacing: 1px;
    }
    .value {
      font-size: 17px;
      &.red {
        color: #E11A1A;
        font-weight: 500;
      }
      &.green {
        color: #0DA22E;
        font-weight: 500;
      }
    }
  }
}
</style>
